import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { SFTP_DOMAIN, MS_SFTP_DOMAIN, MULTISITE_EDITION_NAME } from '../../../globals';
import { Site, SiteService } from '../../core/site';
import { AccountsService } from '../../accounts.service';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
@Component({
  selector: 'app-download-key-dialog',
  templateUrl: './download-key.component.html',
  styleUrls: ['./download-key.styles.scss', './key-list.styles.scss'],
  standalone: false,
})
export class DownloadKeyDialogComponent implements OnInit {
  public disableClose = true;
  public userId = '';
  keyContent: string;
  sftpDomain: string;

  siteUid$: Observable<string>;

  constructor(
    public dialogRef: MatDialogRef<DownloadKeyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private siteService: SiteService,
    private accountsService: AccountsService,
    public readonly analyticsService: ProductAnalyticsService,
  ) {
    this.keyContent = data.keyContent;
  }

  ngOnInit(): void {
    this.siteUid$ = this.siteService.get().pipe(map((site: Site) => site.uid));
    this.accountsService.editionName$.subscribe((editionName: string) => {
      if (editionName === MULTISITE_EDITION_NAME) {
        this.sftpDomain = MS_SFTP_DOMAIN;
      } else {
        this.sftpDomain = SFTP_DOMAIN;
      }
    });
  }

  public closeDialog(): void {
    this.keyContent = '';
    this.dialogRef.close();
  }

  public downloadKey(): void {
    this.analyticsService.trackEvent('sftp:download-key', 'download-sftp-key', 'clicked');
    this.downloadPrivateKey(this.keyContent);
    this.disableClose = false;
    this.dialogRef.disableClose = false;
  }

  public copyKey(): void {
    this.copyPrivateKey(this.keyContent);
    this.disableClose = false;
    this.dialogRef.disableClose = false;
  }

  public downloadPrivateKey(keyContent: string): void {
    const link = document.createElement('a');
    link.download = this.privateKeyFileName();
    link.href = 'data:application/octet-stream;charset=utf-8;base64,' + btoa(keyContent);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  public copyPrivateKey(keyContent: string): void {
    const eventListener = function (e: ClipboardEvent): void {
      e.clipboardData.setData('text/plain', keyContent);
      e.preventDefault();
      document.removeEventListener('copy', eventListener);
    };

    document.addEventListener('copy', eventListener);
    document.execCommand('copy');
  }

  private privateKeyFileName(): string {
    let fileName = '';
    this.siteUid$.pipe(first()).subscribe((siteUid: string) => (fileName = siteUid + '_private_key.pem'));
    return fileName;
  }
}
